import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {AnalyticsService} from "../../../commons/services/analytics-service.service";
import * as moment from "moment/moment";
import {AgentsAlerts} from "../../../agents/services/agents-alerts.service";
import {DeliveriesService} from "../../services/deliveries-service.service";
import {LeanPlanningRequestsService} from "../../../lean-planning/services/plan-requests.factory";
import {SplitService} from "../../../commons/services/split-service.service";
import {ServicesFacadeService} from "../../angular/services/services-facade.service";
import {AddToRouteComponentStore} from "../../angular/state/add-to-route.store";
import {firstValueFrom, Subscription} from "rxjs";
import {RoutesListAdapter} from "./routes-list-adapter";

export class ServicesAssignRouteDialogViewCtrl implements IController {
  serviceIds: any;
  assignAddedDeliveries: boolean;
  onAssign: Function;

  public assignRelatedChecked: boolean;
  public assignableServices: any;
  public unAssignableServices: any;
  public services: any[];
  public settings: any;

  private deliveriesRef: any;
  private _routesList: RoutesListAdapter;
  private _routesSub: Subscription;
  private loading: any;
  private assignData: any;
  private assignedRoute: any;
  private queryString: any;
  private totalServices: any;
  private unpackedDeliveryIds: any;
  private mode: any;
  public from: any;
  public to: any;
  public isMobile: boolean;
  public routesList: any;

  private readonly ROUTES_PAGE_SIZE = 20;

  /* @ngInject */
  constructor(private $delivery, private $log, private deliveriesService: DeliveriesService,
              private analyticsService: AnalyticsService, private leanPlanningRequestsService: LeanPlanningRequestsService,
              private agentsAlerts: AgentsAlerts, private $mdMedia, private splitService: SplitService, private servicesFacadeService: ServicesFacadeService,
              private addToRouteStore: AddToRouteComponentStore) {
    this.deliveriesRef = this.$delivery();
  }

  $onInit() {
    this.loading = true;
    this.assignableServices = [];
    this.unAssignableServices = [];
    this.assignRelatedChecked = true;
    this.from = undefined;
    this.to = undefined;
    this._routesSub?.unsubscribe();
    this._routesList?.destroy();
    this.addToRouteStore.resetRoutes();
    this._routesList = new RoutesListAdapter(this.addToRouteStore, this.ROUTES_PAGE_SIZE, () => this._getRoutesQueryPayload());
    this.routesList = this._routesList;
    this._routesSub = this.addToRouteStore.routes$.subscribe((routes) => this._setAccountReferences(routes));

    if (this.serviceIds && this.serviceIds.length) {
      this._setAssignData(true)
    }

    this.settings = this.splitService.getSiteServicesAssignRouteSettings();
  }

  $onChanges(changes) {
    if (changes.serviceIds && !changes.serviceIds.isFirstChange()) {
      this.$onInit();
    }
  };

  $onDestroy() {
    this._routesSub?.unsubscribe();
    this._routesList?.destroy();
  }


  $doCheck() {
    this.isMobile = this.$mdMedia('xs');
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onQueryStringChange(queryString) {
    this.queryString = queryString;
    this._reloadRoutesList();
  }

  onAssignToRoute(route) {
    this.mode = 'loading';
    this.analyticsService.trackEvent('Deliveries Actions', 'Assign Route', 'Confirm');

    let totalServicesIds = this.serviceIds;

    if (this.assignRelatedChecked && this.assignableServices.length) {
      const assignableServicesIds = _.map(this.assignableServices, (as: any) => {
        return as.id;
      })
      totalServicesIds = _.union(this.serviceIds, assignableServicesIds);
    }

    this.leanPlanningRequestsService.addServicesToRoute(totalServicesIds, route.id, this.assignAddedDeliveries)
      .then((res) => {
        if (res.serviceList) {
          this.servicesFacadeService.updateMany(res.serviceList);
        }
        this.mode = 'success';
        this._setAccountReferences([route]);
        this.addToRouteStore.setRoutes({routes: [route], cursor: undefined});
        this.assignedRoute = route;

        this.onAssign({route: this.assignedRoute, routedServicesIds: totalServicesIds});
      })
      .catch((error) => {
        this.mode = 'error';
        if (error) {
          this.$log.error('Failed to manually assign deliveries to route', error);
          this.analyticsService.trackEvent('Deliveries Actions', 'Assign Route', 'Error');
        }
      })
  }

  onAssignServicesToggled() {
    this.assignRelatedChecked = !this.assignRelatedChecked;
    this._setAssignData();
  }

  onRangeChange(from, to) {
    if (from === this.from && to === this.to) {
      return;
    }

    this.from = from;
    this.to = to;

    if (this.from >= this.to || this.to <= this.from) {
      return;
    } else {
      this._setAssignData();
    }
  }

  onViewSettingsChange(settings) {
    this.settings = settings;
    this.splitService.setSiteServicesAssignRouteSettings(settings);
  }

  // ******************************
  //        Private methods
  // ******************************

  private _setAssignData(shouldSetRange?) {

    this.loading = true;
    this.assignData = undefined;
    this.unpackedDeliveryIds = undefined;


    return this.deliveriesRef.$asyncValues(this.serviceIds)
      .then((services) => {
        this.services = services;

        if (!!shouldSetRange) {
          _.forEach(services, (s) => {
            this.from = (!this.from || moment(s.notBefore).startOf('day').valueOf() < this.from) ? moment(s.notBefore).startOf('day').valueOf() : this.from;
            this.to = (!this.to || moment(s.notAfter).endOf('day').valueOf() > this.to) ? moment(s.notAfter).endOf('day').valueOf() : this.to;
          })
        }

        if (!this.assignRelatedChecked) {
          return [];
        }
        const relatedServiceIds = this.deliveriesService.getRelatedServicesByTypeMultiple(services, "SupplyTogether");
        if (relatedServiceIds.length) {
          return this.deliveriesRef.$asyncValues(relatedServiceIds)
        }

      })
      .then((relatedService) => {
        let totalServices = this.serviceIds;
        if (!relatedService) {
          this.assignRelatedChecked = false;
        }

        if (this.assignRelatedChecked && relatedService) {
          this._setRelations(relatedService);
          const assignableServicesIds = _.map(this.assignableServices, (as: any) => {
            return as.id;
          })

          // for the totals
          this.services = _.concat(this.services, this.assignableServices);
          totalServices = _.union(this.serviceIds, assignableServicesIds);
        }
        this.totalServices = totalServices;
        return this._fetchRoutesPage();
      })
      .then((aggregate) => {
        this.assignData = aggregate;
        return this.deliveriesRef.$asyncValues(aggregate.deliveryIds);
      })
      .then((services) => {
        this._setUnpackedDeliveries(services);
        this._setServicesTotals(services);
      })
      .catch((error) => {
        this.agentsAlerts.getManyError();
        this.$log.error('Failed to get assign data ' +
          '@servicesAssignDialogView@_setAssignData', error);
      })
      .finally(() => {
        this.loading = false;
      })
  }

  private _fetchRoutesPage() {
    return firstValueFrom(this.addToRouteStore.fetchAssignRouteData(this._getRoutesQueryPayload()));
  }

  private _reloadRoutesList() {
    if (!this.totalServices) {
      return;
    }
    this.loading = true;
    firstValueFrom(this.addToRouteStore.fetchAssignRouteData(this._getRoutesQueryPayload()))
      .catch((error) => {
        this.agentsAlerts.getManyError();
        this.$log.error('Failed to load routes ' +
          '@servicesAssignDialogView@_reloadRoutesList', error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private _getRoutesQueryPayload() {
    return {
      ids: this.totalServices,
      from: this.from,
      to: this.to,
      query: this.queryString,
      expand: false,
      limit: this.ROUTES_PAGE_SIZE
    };
  }

  private _setAccountReferences(routes) {
    _.forEach(routes, (route) => {
      const accountsMap = {};
      _.forEach(route.routeTaskList, (task) => {
        if (task.accountReference && !accountsMap[task.accountReference.id]) {
          accountsMap[task.accountReference.id] = task.accountReference;
        }
      });
      route.accountReferences = _.values(accountsMap);
    });
  }

  private _setUnpackedDeliveries(services) {
    this.unpackedDeliveryIds = this.deliveriesService.getUnpackedDeliveryIds(services);
  }

  private _setServicesTotals(services) {
    this.assignData.deliveriesCount = 0;
    this.assignData.fieldServicesCount = 0;

    _.forEach(services, (s) => {
      if (s.serviceType === 'Delivery') {
        this.assignData.deliveriesCount++;
      }
      if (s.serviceType === 'Operation') {
        this.assignData.fieldServicesCount++;
      }
    })
  }

  private _setRelations(relatedServices: any): void {

    const assignableServices = relatedServices.filter((relatedService) => {
      return !(relatedService.status == "Completed" || relatedService.status == "Canceled");
    });

    const unAssignableServices = _.differenceBy(relatedServices, this.assignableServices);

    // relatedServices entities may be shared, frozen references (e.g. from the NgRx store),
    // so clone them before ng-repeat tries to stamp a $$hashKey onto them.
    this.assignableServices = angular.copy(assignableServices);
    this.unAssignableServices = angular.copy(unAssignableServices);
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('servicesAssignRouteDialogView', {
    bindings: {
      serviceIds: '<',
      settings: '<',
      assignAddedDeliveries: '<?',
      onAssign: '&',

    },
    template: require('./services-assign-route-dialog-view.html').default,
    controller: ServicesAssignRouteDialogViewCtrl
  });
